import { INDETERMINATE } from '@repo/constants'

export type TriStateValue = boolean | typeof INDETERMINATE | undefined

export const getNextTristateValue = (value: TriStateValue): TriStateValue => {
  switch (value) {
    case false:
      return INDETERMINATE
    case INDETERMINATE:
    case undefined:
      return true
    case true:
    default:
      return false
  }
}
